import { isFalsy } from 'lib/Helpers';

/**
 * Get the Appropriate Error Message for Segment Name Input
 * @function getErrorMessage
 * @param {Object} param
 * @property {boolean} duplicateNameValid
 * @property {boolean} isNameUnique
 * @property {string} name
 * @return {string}
 */
const getErrorMessage = ({ isNameUnique, nameValid, name }) => {
  if (isFalsy(name)) return 'A segment name is required';
  else if (isFalsy(nameValid)) return 'Only the following special characters are supported: *-_#$';
  else if (isFalsy(isNameUnique)) return 'This segment name already exists, please try again';
  return null;
};

export default getErrorMessage;
